import { DialogConfig } from '../../common/models';
import { put, take } from 'redux-saga/effects';
import { commonActions } from '../../common';
import { ActionType } from '../../../utils/reduxUtils';

export default function* takeConfirmation(config: DialogConfig) {
  yield put(commonActions.showDialog(config));
  const confirmed: ActionType<typeof commonActions.hideDialog> = yield take(commonActions.hideDialog.type);
  return confirmed.payload;
}
